import type { ReceiptTemplate } from '../schema';

export const shellTemplate: ReceiptTemplate = {
  id: 'shell',
  name: 'Shell Gas Receipt',
  brand: 'SHELL',
  description: 'Shell gas station receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'shell-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/shell.png',
        logoData: '',
        logoWidth: 80,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'shell-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 2:45 PM\nPUMP #4',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'shell-fuel',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'shell-grade', label: 'V-POWER NITRO+', value: '', isBold: false, isLarge: false },
          { id: 'shell-gallons', label: 'GALLONS', value: '12.847', isBold: false, isLarge: false },
          { id: 'shell-ppg', label: 'PRICE/GAL', value: '4.599', isBold: false, isLarge: false },
          { id: 'shell-total', label: 'FUEL TOTAL', value: '59.08', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'shell-rewards',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'FUEL REWARDS MEMBER\nSAVINGS: $0.05/GAL = $0.64',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'shell-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4847',
        fields: [
          { id: 'shell-auth', label: 'AUTH:', value: '847291' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'shell-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'V-POWER NITRO+ PREMIUM\nGO WELL\n\nTHANK YOU\nPLEASE COME AGAIN',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};
